import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../section_title';
import { TOptimizationSection } from './types';
import './OptimizationSection.scss';
import { getTranslationNode } from '../services';
import { TCreativeTranslation } from '../../../../redux/creativeAnalytics/creativeVideoDetails/types';

const OptimizationSection: React.FC<TOptimizationSection> = ({
  creative_summary,
  optimization
}) => {
  const { t, i18n } = useTranslation();
  const [summary, setSummary] = useState<string | undefined>(undefined);
  const [detail, setDetail] = useState<string | undefined>(undefined);

  useEffect(() => {
    const language = (i18n.language || i18n.resolvedLanguage) ?? 'en';
    const summaryNode =
      typeof creative_summary === 'string'
        ? creative_summary
        : creative_summary?.[language as keyof TCreativeTranslation];
    const optimizationNode = getTranslationNode(optimization, language);
    setSummary(summaryNode);
    setDetail(optimizationNode);
  }, [creative_summary, optimization, i18n]);

  return (
    <div className="optimization_section_container">
      <SectionTitle
        title={t('creative_video_details.section_title.optimization_section')}
        iconClassName="tim-icons icon-atom"
      />
      <div className="optimization_section">
        <div className="optimization_summary">{summary}</div>
        <div className="optimization_detail">{detail}</div>
      </div>
    </div>
  );
};

export default OptimizationSection;
